/**
 * CustomerSpeed.API
 * API that manages account-specific speed limit overrides.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LinkDto } from './linkDto';
import { OverrideSegmentDto } from './overrideSegmentDto';

/**
 * DTO representing a speed override for a road segment. This is the main response model for override operations.
 */
export interface OverrideDto {
  /**
   * The unique identifier for the override (GUID).
   */
  id: string | null;
  /**
   * The user-defined name for this override. Example: \"US-101 Construction Zone\"
   */
  name: string | null;
  /**
   * The real-time status of this override: ACTIVE, PLANNED, or EXPIRED. Computed at query time from startDate/endDate vs current UTC time.
   */
  status: OverrideDto.StatusEnum;
  /**
   * The road name(s) associated with this override. Example: \"US-101 / Little Redwood Ln\"
   */
  roadName: string | null;
  /**
   * The city name associated with this override\'s road segment, if available.
   */
  cityName?: string | null;
  /**
   * The direction of travel for this override (FORWARD, BACKWARD, or BOTH).
   */
  direction: OverrideDto.DirectionEnum;
  /**
   * The speed override value in km/h.
   */
  speedOverwriteInKmh: number;
  /**
   * The start date for this override.
   */
  startDate: string;
  /**
   * The optional end date for this override.
   */
  endDate?: string | null;
  /**
   * Optional notes associated with this override. Example: \"Construction zone\"
   */
  notes?: string | null;
  /**
   * The timestamp when this override was created.
   */
  createdAt: string;
  /**
   * The segments involved in this override, each with coordinates, segment identifiers, and geometry.
   */
  segments: Array<OverrideSegmentDto> | null;
  /**
   * HATEOAS links for this resource.
   */
  links?: Array<LinkDto> | null;
}
export namespace OverrideDto {
  export type StatusEnum = 'ACTIVE' | 'PLANNED' | 'EXPIRED';
  export const StatusEnum = {
    Active: 'ACTIVE' as StatusEnum,
    Planned: 'PLANNED' as StatusEnum,
    Expired: 'EXPIRED' as StatusEnum
  };
  export type DirectionEnum = 'FORWARD' | 'BACKWARD' | 'BOTH';
  export const DirectionEnum = {
    Forward: 'FORWARD' as DirectionEnum,
    Backward: 'BACKWARD' as DirectionEnum,
    Both: 'BOTH' as DirectionEnum
  };
}
